import "./App.css";
import Translate from "./components/Translate";
import Footer from "./components/Footer";
function App() {
  return (
    <>
      <Translate />
      <Footer />
    </>
  );
}

export default App;
